<button
    qpxButton
    matIconButton
    size="sm"
    cdkDragHandle
    [matMenuTriggerFor]="actions"
    class="grip compact"
    [disabled]="disabled()"
    [attr.aria-label]="`Actions for section ${group().name}`"
>
    <ng-icon qpx size="sm" name="lucideGripVertical" />
</button>
<div class="header-name">
    <span class="name-width" aria-hidden="true">{{ group().name }}</span>
    <mat-form-field
        qpxInput
        size="sm"
        class="w-full alt-bg"
        subscriptSizing="dynamic"
        ><input
            matInput
            aria-label="Section name"
            [id]="`${actionId()}-section-${group().key}`"
            maxlength="200"
            [disabled]="disabled()"
            [ngModel]="group().name"
            (ngModelChange)="
                draft.renameSection(group().key, $event); changed.emit()
            "
    /></mat-form-field>
</div>
<button
    qpxButton
    matIconButton
    size="sm"
    class="action compact"
    [disabled]="disabled()"
    [attr.aria-label]="`Delete section ${group().name}`"
    (click)="removed.emit()"
>
    <ng-icon qpx size="sm" name="lucideTrash2" context="destructive" />
</button>
<mat-menu #actions="matMenu" xPosition="after" yPosition="below">
    <button
        mat-menu-item
        type="button"
        [disabled]="disabled() || sectionIndex() === 0"
        [attr.aria-label]="`Move section ${group().name} up`"
        (click)="
            draft.moveSection(sectionIndex(), sectionIndex() - 1);
            changed.emit()
        "
    >
        <ng-icon qpx size="sm" name="lucideArrowUp" matMenuItemIcon /><span
            >Move up</span
        >
    </button>
    <button
        mat-menu-item
        type="button"
        [disabled]="disabled() || last()"
        [attr.aria-label]="`Move section ${group().name} down`"
        (click)="
            draft.moveSection(sectionIndex(), sectionIndex() + 1);
            changed.emit()
        "
    >
        <ng-icon qpx size="sm" name="lucideArrowDown" matMenuItemIcon /><span
            >Move down</span
        >
    </button>
</mat-menu>
